import React, { useCallback } from 'react';
import 'css/EventItemContainer/GroupEventItem.scss';
import { ViewEventListContainer } from '../ViewEventList/styled';
import GroupEventItemHeader from '../../components/GroupEventItemHeader/GroupEventItemHeader';
import { getGroupEventList } from './helper';
import GroupEventItemList from '../../components/GroupEventItemList/GroupEventItemList';

const GroupEventItem = ({
    events,
    showFavorites,
    limit,
    trackClickEvent,
    userId = 0,
    isLive,
}) => {
    if (!events) {
        return null;
    }

    let vinderspilQuantity = 0;

    if (event?.marketList?.length) {
        event.marketList.map((item) => {
            if (item.type === 'Vinderspil') {
                vinderspilQuantity++;
            }
        });
    }

    const isEventFromButton = (target, currentTarget) => {
        while (target && target !== currentTarget) {
            if (target.tagName === 'BUTTON') {
                return true;
            }
            target = target.parentNode;
        }
        return false;
    };

    const handleItemClick = useCallback(
        (data, e) => {
            if (
                (e.currentTarget === e.target ||
                    !isEventFromButton(e.target, e.currentTarget)) &&
                !events[0].vaixIndex
            ) {
                e.preventDefault();
                e.stopPropagation();
                const path = window.location.pathname;
                let widgetType;
                if (events[0].live && isLive) {
                    widgetType =
                        'sr-widget:livepagebetrecommendation.eventlist:recommended';
                } else if (events[0].live) {
                    widgetType =
                        'sr-widget:livebetrecommendation.eventlist:recommended';
                } else {
                    widgetType =
                        'sr-widget:prematchbetrecommendation.eventlist:recommended';
                }
                if (typeof trackClickEvent === 'function') {
                    trackClickEvent(
                        'clicks:event',
                        `sr:match:${data.externalId}`,
                        'event_id',
                        widgetType,
                        path,
                        userId || 0
                    );
                }
            }
        },
        [events, isLive, trackClickEvent, userId, window.location.pathname]
    );

    const { header: headerOptions, eventsToRender } = getGroupEventList(
        events,
        limit
    );

    const groupTitle = `${events[0]?.sport} • ${events[0]?.groupName} • ${
        events[0]?.competition
    }`;

    return (
        <ViewEventListContainer className="simplified">
            <GroupEventItemHeader
                events={events}
                options={headerOptions}
                title={groupTitle}
            />
            <GroupEventItemList
                events={eventsToRender}
                headerOptions={headerOptions}
                handleItemClick={handleItemClick}
                userId={userId}
                showFavorites={showFavorites}
            />
        </ViewEventListContainer>
    );
};

export default GroupEventItem;
